import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './PassengerSummary.scss';

class PassengerSummary extends Component {
    state = {
        showMorePassengers: false
    }

    showPassengersHandler = () => {
        this.setState({
            showMorePassengers: true
        })
    }

    hidePassengersHandler = () => {
        this.setState({
            showMorePassengers: false
        })
    }

    render() {
        const firstPax = `${this.props.passengers[0].travellerDetails.title}. ${this.props.passengers[0].travellerDetails.firstName} ${this.props.passengers[0].travellerDetails.lastName}`
        return (
            <div className="pt-3 pb-3 u-borderTopNormal u-borderBottomNormal">
                <div className="u-flex mb-2">
                    <p className="u-textColorDark u-fontWeightMedium u-fontSize13">{firstPax}</p>
                    {this.props.passengers.length > 1 ? (
                        <React.Fragment>
                            <p className={`${classes.PaxListBox} u-flex justify-content-center align-items-center u-cursorPointer u-relative u-textColorWhite u-backgroundColorNormalBlue u-fontSize11 u-fontWeightMedium ml-3 u-borderRadius3`} onMouseEnter={this.showPassengersHandler} onMouseLeave={this.hidePassengersHandler}>+{this.props.passengers.length - 1}
                                {this.state.showMorePassengers ? <div className={classes.SelectPax}>
                                    <ul>
                                        {this.props.passengers.map((passenger, index) => {
                                            if(index !== 0) {
                                                return <li key={index} className={classes.PaxListItem}><span>{passenger.travellerDetails.firstName + ' ' + passenger.travellerDetails.lastName}</span></li>
                                            }
                                            return null;
                                        })}
                                    </ul>
                                </div> : null}
                            </p>
                        </React.Fragment>
                    ) : null}
                </div>
                <div>
                    <p className="u-textColorLight u-fontSize13 u-fontWeightRegular">Email: {this.props.email}</p>
                    <p className="u-textColorLight u-fontSize13 u-fontWeightRegular">Phone: +{this.props.mobileISD} {this.props.mobile}</p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        passengers: state.farePrice.passengers,
        email: state.farePrice.userParams.additionalContact.email,
        mobile: state.farePrice.userParams.additionalContact.mobile,
        mobileISD: state.farePrice.userParams.additionalContact.mobileISD
    }
}

export default connect(mapStateToProps)(PassengerSummary);


// WEBPACK FOOTER //
// ./src/components/Payment/PassengerSummary/PassengerSummary.js